// extracted by mini-css-extract-plugin
module.exports = {"warning":"CartLimitError_warning__rrZwM"};